// extracted by mini-css-extract-plugin
module.exports = {"clickable":"shared_clickable__AEcIM","centered":"shared_centered__2bNl9","square":"shared_square__gNXLq"};